import { createContext, useCallback, useMemo } from 'react';
import useGenericContext from 'hooks/useGenericContext';
import useLocalStorage from 'hooks/useLocalStorage';

const PreferencesContext = createContext(null);
const PreferencesFunctionsContext = createContext(null);

const initialValues = {
  show_deactivate_activity_warning: true,
  show_deactivate_address_warning: true,
  show_deactivate_employee_warning: true,
  show_delete_activity_warning: true,
  show_delete_address_warning: true,
  show_delete_employee_warning: true,
};

const PreferencesProvider = ({ children }) => {
  const [preferences, setPreferences] = useLocalStorage('user-preferences', initialValues);

  const changePreference = useCallback(
    (key, value) => {
      setPreferences({
        ...preferences,
        [key]: value,
      });
    },
    [preferences, setPreferences],
  );

  const values = useMemo(
    () => ({
      preferences,
    }),
    [preferences],
  );

  const functions = useMemo(
    () => ({
      changePreference,
    }),
    [changePreference],
  );

  return (
    <PreferencesContext.Provider value={values}>
      <PreferencesFunctionsContext.Provider value={functions}>{children}</PreferencesFunctionsContext.Provider>
    </PreferencesContext.Provider>
  );
};

/**
 * Return the items values.
 */
function usePreferences() {
  return useGenericContext(
    PreferencesContext,
    'usePreferences cannot be used outside of a PreferencesProvider component.',
  );
}

/**
 * Return the functions manipulating items.
 */
function usePreferencesFunctions() {
  return useGenericContext(
    PreferencesFunctionsContext,
    'usePreferencesFunctions cannot be used outside of a PreferencesProvider component',
  );
}

export { PreferencesProvider, usePreferences, usePreferencesFunctions };
